import React from 'react';
import './ButtonSet.css';

const ButtonSet = ({ onSourceChange }) => {
    return (
        <div className="button-set">
            <button className="btn" onClick={() => onSourceChange('local')}>Local</button>
            <button className="btn" onClick={() => onSourceChange('remote')}>Remote</button>
        </div>
    );
};

export default ButtonSet;
